import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
  name: 'dateToUtc'
})
export class DateToUtcPipe implements PipeTransform {

  transform(value: any, format?: any): any {
    var date = new Date(value);
    if (!format) {
      format = 'MM/DD/YYYY';
    }
    return moment.utc(date).format(format);
  }

}



// WEBPACK FOOTER //
// ./src/app/common/pipes/date-to-utc.pipe.ts